import { AxiosError } from 'axios';
import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { contactsApi } from 'src/Services/API';
import { ContactDeletionCheckDto } from 'src/Services/API/generated';
import { ApiError } from 'src/types/api-error.types';

export const useFetchContactDeletionCheck = (contactId: string | null) => {
  const assetId = useCurrentAssetId();

  return useQuery<ContactDeletionCheckDto, AxiosError<ApiError>>({
    queryKey: ['fetch-contact-deletion-check', assetId, contactId],
    queryFn: async () => {
      if (!assetId || !contactId) throw new Error('assetId and contactId are required');
      return (await contactsApi.contactsControllerGetDeletionCheck(contactId, assetId)).data;
    },
    enabled: !!assetId && !!contactId,
    staleTime: 0,
    refetchOnMount: 'always',
  });
};
